import { Virtuoso } from 'react-virtuoso';
import useVirtualListStyle from 'hooks/use-virtial-list-style';
import Loader from 'components/loader';
import NotFound from 'components/not-found';
import ErrorMessage from 'components/error-message';
import LoadMoreVirtualListFooter from 'components/load-more-virtual-list-footer';
import styles from './styles.module.scss';
import FavoriteListItem from 'components/favorite-list-item';
import useFavoriteList from 'api/hooks/use-favorite-list';
import { useEffect, useState } from 'react';
import { Select } from 'components/select';
import { APIUserType, MarketTypes } from 'api/types';
import iconPlus from 'assets/images/icon-plus.svg';
import IconButton from 'components/icon-button';
import { BottomSheet } from 'react-spring-bottom-sheet';
import CreateFavoriteListForm from 'components/favorite-list-item/forms/createListForm';
import { EFavoritesType } from 'lib/types';
import useBoundStore from 'store';
import { getName } from 'lib/utils';
import { Input } from 'components/input';
import clsx from 'clsx';
import Header from 'components/header';
import { FavouritesType } from 'lib/dictionary';

interface IApartmentFavoritesProps {
  type: EFavoritesType;
}

const ApartmentFavorites = ({ type }: IApartmentFavoritesProps) => {
  const favoriteMarketTypeByFavTypeListSelected = useBoundStore(
    (s) => s.favoriteMTypeByFavTypeListSelected,
  )[`${type}`];
  const favoriteSearchByFavTypeListSelected = useBoundStore(
    (s) => s.favoriteSearchByFavTypeListSelected,
  )[`${type}`];

  const setFavoriteMarketTypeByFavTypeListSelected = useBoundStore(
    (s) => s.setFavoriteMTypeByFavTypeListSelected,
  );
  const setFavoriteSearchByFavTypeListSelected = useBoundStore(
    (s) => s.setFavoriteSearchByFavTypeListSelected,
  );

  const payload = { types: [type], marketType: favoriteMarketTypeByFavTypeListSelected };
  const { favoriteList, isLoading, isValidating, error, mutate } = useFavoriteList(payload);

  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [isMount, setIsMount] = useState(true);
  const user = useBoundStore((s) => s.user);

  useEffect(() => {
    setIsMount(false);
  }, []);

  useEffect(() => {
    if (!isMount) {
      fetchFavoriteList();
    }
  }, [type, favoriteMarketTypeByFavTypeListSelected]);

  const fetchFavoriteList = () => {
    mutate();
  };

  const listStyle = useVirtualListStyle();

  const listFiltered = favoriteSearchByFavTypeListSelected
    ? favoriteList?.filter((favorite) =>
        favorite.title.includes(favoriteSearchByFavTypeListSelected),
      )
    : favoriteList;

  const isWidth = user?.type === APIUserType.CLIENT;

  return (
    <>
      <div className={styles.menu}>
        <div className={clsx(styles.select, isWidth && styles.select_full)}>
          <Select
            onSelect={(value: MarketTypes) =>
              setFavoriteMarketTypeByFavTypeListSelected(type, value)
            }
            selected={favoriteMarketTypeByFavTypeListSelected}
            menuArray={[
              { label: 'Первичка', key: MarketTypes.PRIMARY },
              { label: 'Вторичка', key: MarketTypes.SECONDARY },
            ]}
            label='Тип'
            size='md'
            multiple={false}
          />
        </div>
        {type === EFavoritesType.Personal && (
          <div className={styles.menuButton}>
            <IconButton icon={iconPlus} onClick={() => setIsBottomSheetOpen(true)} />
          </div>
        )}
      </div>
      <div>
        <Input
          isMainPlaceholder
          placeholder='Укажите имя списка'
          className={clsx(styles.input, isWidth && styles.input_full)}
          value={favoriteSearchByFavTypeListSelected}
          onChange={(value) => setFavoriteSearchByFavTypeListSelected(type, value)}
          label='Поиск по названию'
          size='md'
        />
      </div>
      {error && listFiltered?.length === 0 ? (
        <ErrorMessage className={styles.margined} message={error} />
      ) : isLoading ? (
        <Loader className={styles.margined} />
      ) : Boolean(listFiltered?.length) ? (
        <div>
          <Virtuoso
            useWindowScroll
            data={listFiltered}
            style={listStyle}
            className={styles.container}
            itemContent={(index, favorite) => {
              const isOwner = user?.id && favorite.owners.map((user) => user.id).includes(user?.id);
              const isClient = user?.type === APIUserType.CLIENT;
              const strName = getName(favorite?.clients[0]?.fullname);
              const usersStr = favorite?.clients?.length > 1 ? strName + '...' : strName;

              return (
                <FavoriteListItem
                  {...favorite}
                  clients={usersStr}
                  isOwner={Boolean(isOwner)}
                  isClient={isClient}
                  type={type}
                  refetchFavoriteList={fetchFavoriteList}
                />
              );
            }}
            components={{ Footer: LoadMoreVirtualListFooter }}
          />
        </div>
      ) : (
        <NotFound />
      )}
      <BottomSheet
        header={<Header text={`${FavouritesType.label(EFavoritesType.Personal)} список`} />}
        open={isBottomSheetOpen}
        onDismiss={() => setIsBottomSheetOpen(false)}
        snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight]}
        blocking={false}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: 20 }}>
          {
            <CreateFavoriteListForm
              refetchFavoriteList={fetchFavoriteList}
              onClose={() => setIsBottomSheetOpen(false)}
            />
          }
        </div>
      </BottomSheet>
    </>
  );
};

export default ApartmentFavorites;
